import TablePage from "@beeldit/core/pages/TablePage";
import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import { Booking } from "../models/Booking";
import BookingsTablePage from "../components/BookingsTablePage";
import { CancelActionProvider } from "../actions/cancel/CancelActionContext";
import { UncancelActionProvider } from "../actions/uncancel/UncancelActionContext";
import { EditActionProvider as CustomerEditActionProvider } from "@main/customers/actions/edit/EditActionContext";

function BookingPage() {
  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  };

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <CustomerEditActionProvider>
          <EditActionProvider>
            <CancelActionProvider>
              <UncancelActionProvider>
                <BookingsTablePage {...tablePageParams} />
              </UncancelActionProvider>
            </CancelActionProvider>
          </EditActionProvider>
          </CustomerEditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default BookingPage;
